import type { PDSPrice } from "@expert/types";

export const getPrice = (articleId: string, store: Ref<Store> | Ref<string>, liveCheck: boolean, lazy?: boolean) => {
	const logger = useLogger('expPrice');

	const query: Record<string, string> = {};
	if (articleId?.startsWith("e_")) {
		query["articleId"] = articleId;
	} else {
		query["webcode"] = articleId;
	}
	query["storeId"] = store?.value?.id ?? store?.value;

	if (!query['articleId'] && !query['webcode']) {
		logger.trace('Called getPrice with neither articleId nor webcode');
		return { pending: false, data: ref(undefined) };
	}

	return useFetch<PDSPrice>(useRuntimeConfig().public.apiUrl + '/api/pricepds', {
		key: "pricepds/webcode=" + articleId + ";storeId=" + (store?.value?.id ?? store?.value),
		query: query,
		server: false,
		credentials: 'include',
		referrerPolicy: 'no-referrer-when-downgrade',
		onRequest({request, options}) {
			options.headers.set('x-bt-reff', liveCheck ? 'checkout': 'none');
		},
		dedupe: 'defer',
		lazy: lazy ?? true,
		watch: [store, useCurrentStore(), computed( () => useRoute()?.query?.branch_id?.toString())]
	});
}
